/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import useSwr from 'swr';
import type { SWRConfiguration, Key } from 'swr';
import type {
  UserRoleEntity,
  UserRemoveRoleFromUserResponseDto,
  UserEntity,
  CreateUserDto,
  UserFindAllResponseDto,
  UsersControllerFindAllParams,
  UserWithOrganizationRoles,
  UpdateUserDto,
  UserDetailsResponseDto,
  RetailerLocationsWithLicensesResponseDto,
} from '../nabisNYWebAPI.schemas';

export const usersControllerAddRoleToUser = (
  id: string,
  roleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserRoleEntity>> => {
  return axios.post(`/api/v1/users/${id}/role/${roleId}`, undefined, options);
};

export const usersControllerRemoveRoleFromUser = (
  id: string,
  roleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserRemoveRoleFromUserResponseDto>> => {
  return axios.delete(`/api/v1/users/${id}/role/${roleId}`, options);
};

export const usersControllerCreate = (
  createUserDto: CreateUserDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserEntity>> => {
  return axios.post(`/api/v1/users`, createUserDto, options);
};

export const usersControllerFindAll = (
  params: UsersControllerFindAllParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserFindAllResponseDto>> => {
  return axios.get(`/api/v1/users`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUsersControllerFindAllKey = (params: UsersControllerFindAllParams) =>
  [`/api/v1/users`, ...(params ? [params] : [])] as const;

export type UsersControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerFindAll>>>;
export type UsersControllerFindAllQueryError = AxiosError<unknown>;

export const useUsersControllerFindAll = <TError = AxiosError<unknown>>(
  params: UsersControllerFindAllParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersControllerFindAll>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersControllerFindAllKey(params) : null));
  const swrFn = () => usersControllerFindAll(params, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const usersControllerFindOne = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserWithOrganizationRoles>> => {
  return axios.get(`/api/v1/users/${id}`, options);
};

export const getUsersControllerFindOneKey = (id: string) => [`/api/v1/users/${id}`] as const;

export type UsersControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerFindOne>>>;
export type UsersControllerFindOneQueryError = AxiosError<unknown>;

export const useUsersControllerFindOne = <TError = AxiosError<unknown>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersControllerFindOne>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersControllerFindOneKey(id) : null));
  const swrFn = () => usersControllerFindOne(id, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const usersControllerUpdate = (
  id: string,
  updateUserDto: UpdateUserDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserEntity>> => {
  return axios.patch(`/api/v1/users/${id}`, updateUserDto, options);
};

export const usersControllerRemove = (id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/v1/users/${id}`, options);
};

export const usersControllerRestore = (id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
  return axios.patch(`/api/v1/users/${id}/restore`, undefined, options);
};

export const appUserControllerUserDetails = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserDetailsResponseDto>> => {
  return axios.get(`/api/v1/app-user`, options);
};

export const getAppUserControllerUserDetailsKey = () => [`/api/v1/app-user`] as const;

export type AppUserControllerUserDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof appUserControllerUserDetails>>
>;
export type AppUserControllerUserDetailsQueryError = AxiosError<unknown>;

export const useAppUserControllerUserDetails = <TError = AxiosError<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof appUserControllerUserDetails>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  axios?: AxiosRequestConfig;
}) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAppUserControllerUserDetailsKey() : null));
  const swrFn = () => appUserControllerUserDetails(axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const appUserControllerLicensedLocations = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RetailerLocationsWithLicensesResponseDto[]>> => {
  return axios.get(`/api/v1/app-user/licensed-locations`, options);
};

export const getAppUserControllerLicensedLocationsKey = () => [`/api/v1/app-user/licensed-locations`] as const;

export type AppUserControllerLicensedLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof appUserControllerLicensedLocations>>
>;
export type AppUserControllerLicensedLocationsQueryError = AxiosError<unknown>;

export const useAppUserControllerLicensedLocations = <TError = AxiosError<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof appUserControllerLicensedLocations>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  axios?: AxiosRequestConfig;
}) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAppUserControllerLicensedLocationsKey() : null));
  const swrFn = () => appUserControllerLicensedLocations(axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
